var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPageArrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2885 12.2174L8.98798 8.12176C8.67067 7.81957 8.67067 7.32962 8.98798 7.02742C9.30528 6.72523 9.81972 6.72523 10.137 7.02742L15.012 11.6703C15.3293 11.9725 15.3293 12.4624 15.012 12.7646L10.137 17.4075C9.81972 17.7097 9.30528 17.7097 8.98798 17.4075C8.67067 17.1053 8.67067 16.6153 8.98798 16.3131L13.2885 12.2174Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPageArrowPagination);
export default __webpack_public_path__ + "static/media/next-page-arrow-pagination.989882e045823fbc462e11d49083ccc5.svg";
export { ForwardRef as ReactComponent };